import React, { useEffect, useState } from 'react';
import AdminSearchBarHeader from '../component/AdminSearchBarHeader';
import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Image,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Upload,
  message,
} from 'antd';
import routes from '../../../controller/Routes';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Icons } from '../../../controller/Images';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { CloseOutlined } from '@ant-design/icons';
import { getAdminDetail } from '../../../controller/localStroageHandler';
import { enterOnlyNumber } from '../../../controller/global';
import { userCreate } from '../../../controller/api/userServices'

const AddAndEditUser = () => {
  const params = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm();
  const navigate=useNavigate()
  useEffect(() => {
    if (params.id) {

    } else {
      let userDetail = getAdminDetail()
      form.setFieldValue('organization_id', userDetail?.organization_id?._id)
    }
  }, [])

  const handleSubmit = async (val) => {
    const { firstName, lastName, password, email, phoneNo, role, organization_id } = val;
    let payload = {
      firstName,
      lastName,
      password,
      email,
      phoneNo,
      role
    }
    await userCreate(payload, { id: organization_id }).then((res) => {
      form.resetFields()
      message.success(res?.data?.message)
      navigate(routes?.admin?.dashboard?.user?.self)

    }).catch(err => {
      console.log("err ===>", err)
      message.error(err?.response?.data?.message || "Something went wrong")
    })
  }
  return (
    <div className='w-100 h-100 p-4 bg-light overflow-y-auto'>
      <AdminSearchBarHeader />
      <Row align={'middle'} className='mt-2 mb-2'>
        <Col span={24} className='fs-5 fw-semibold'>
          <Breadcrumb
            items={[
              {
                title: (
                  <Link
                    to={routes.admin.dashboard.user.self}
                    className='text-decoration-none text-capitalize'
                  >
                    Organization User
                  </Link>
                ),
              },
              {
                title: (
                  <div className='text-capitalize'>
                    {location.pathname?.split('/')[3]}
                  </div>
                ),
              },
            ]}
          />
        </Col>
      </Row>
      <Card>
        <Spin spinning={loading}>
          <Form
            form={form}
            onFinish={(val) => handleSubmit(val)}
          >
            <Row gutter={[12, 12]}>
              <Col xl={8} lg={12} md={12} sm={12} xs={24} className='lh-lg'>
                <span className='fw-medium fs-6'>FirstName</span>
                <Form.Item name='firstName' label=""
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the first name'
                    }
                  ]}
                >
                  <Input className='w-100' />
                </Form.Item>
              </Col>
              <Col xl={8} lg={12} md={12} sm={12} xs={24} className='lh-lg'>
                <span className='fw-medium fs-6'>LastName</span>
                <Form.Item name='lastName' label=""
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the last name'
                    }
                  ]}
                >
                  <Input className='w-100' />
                </Form.Item>
              </Col>
              <Col xl={8} lg={12} md={12} sm={12} xs={24} className='lh-lg'>
                <span className='fw-medium fs-6'>Email</span>
                <Form.Item name='email' label=""
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the Email'
                    },
                    {
                      pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
                      message: 'Enter Vaild Email',
                    }
                  ]}
                >
                  <Input className='w-100' />
                </Form.Item>
              </Col>
              <Col xl={8} lg={12} md={12} sm={12} xs={24} className='lh-lg'>
                <span className='fw-medium fs-6'>phoneNo</span>
                <Form.Item name='phoneNo' label=""
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the Phone Number'
                    },
                    {
                      min: 10,
                      message: "plase Enter 10 Digit Phone Number"
                    }
                  ]}
                >
                  <Input className='w-100' maxLength={10} onKeyPress={(event) => enterOnlyNumber(event)} />
                </Form.Item>
              </Col>
              <Col xl={8} lg={12} md={12} sm={12} xs={24} className='lh-lg'>
                <span className='fw-medium fs-6'>Password</span>
                <Form.Item name='password' label=""
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the Password'
                    }
                  ]}
                >
                  <Input.Password className='w-100' />
                </Form.Item>
              </Col>
              <Col xl={8} lg={12} md={12} sm={12} xs={24} className='lh-lg'>
                <span className='fw-medium fs-6'>Confirm Password</span>
                <Form.Item name='cpassword' label=""
                  dependencies={['password']}
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the Comfirm Password'
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Comfirm Password don't match with Password!"));
                      },
                    }),
                  ]}
                >
                  <Input.Password className='w-100' />
                </Form.Item>
              </Col>
              <Col xl={12} lg={12} md={12} sm={12} xs={24} className='lh-lg'>
                <span className='fw-medium fs-6'>Role</span>
                <Form.Item name='role' label=""
                  rules={[
                    {
                      required: true,
                      message: 'Please select the role'
                    }
                  ]}
                >
                  <Select>
                    <Select.Option value={'user'} >User</Select.Option>
                    {/* <Select.Option value={'admin'} >Admin</Select.Option> */}
                  </Select>
                </Form.Item>
              </Col>
              <Col xl={12} lg={12} md={12} sm={12} xs={24} className='lh-lg'>
                <span className='fw-medium fs-6'>organization Id</span>
                <Form.Item name='organization_id' label=""
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the organization Id'
                    }
                  ]}
                >
                  <Input disabled={true} />
                </Form.Item>
              </Col>

            </Row>
            <Row >
              <Col xl={12} lg={12} md={12} sm={12} xs={24} className='lh-lg'>
                <Row
                  gutter={[12, 12]}
                  className='h-100 d-flex align-items-center'
                >
                  <Col span={12}>
                    <Button
                      type='default'
                      size='large'
                      className='text-color-custom w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                      onClick={() => { 
                        navigate(routes?.admin?.dashboard?.user?.self)
                      }
                      }
                    >
                      Cencle
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      type='primary'
                      size='large'
                      htmlType='submit'
                      className=' w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center button-color custom-hover-btn'
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    </div>
  );
};

export default AddAndEditUser;
{/* <Col xl={9} lg={10} md={12} sm={12} xs={24}>
<Row
  gutter={[12, 12]}
  className='h-100 d-flex align-items-end'
>
  <Col span={12}>
    <Button
      type='default'
      className='text-color-custom w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
      onClick={() =>
        navigate(routes.admin.dashboard.questionnaire.self)
      }
    >
      Discard
    </Button>
  </Col>
  <Col span={12}>
    <Button
      type='primary'
      className=' w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center button-color custom-hover-btn'
      onClick={() => handleSubmit()}
    >
      Save
    </Button>
  </Col>
</Row>
</Col> */}